/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";

// Images
import team2 from "assets/images/team-2.jpg";

import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Divider from "@mui/material/Divider";

import apiClient from "../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

const ListingsTableData = ({ onRefresh }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [price, setPrice] = useState("");
  const [statusInput, setStatusInput] = useState("Active");
  const [nameFilter, setNameFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [propertyTypeFilter, setPropertyTypeFilter] = useState("");
  const [priceFilter, setPriceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [enlargedImage, setEnlargedImage] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    onConfirm: null,
  });

  const Property = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      {/* <MDAvatar src={image} name={name} size="sm" /> */}
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Category = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  // Fetch states data
  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/listings");
      // Sort listings by added date in descending order (most recent first)
      const sortedListings = response.data.sort((a, b) => {
        const dateA = new Date(a.added?.at || a.added_at || a.createdAt || 0);
        const dateB = new Date(b.added?.at || b.added_at || b.createdAt || 0);
        return dateB - dateA;
      });
      setData(sortedListings);
    } catch (error) {
      console.error("Error fetching listings data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, [onRefresh]);

  // Handlers
  const handleActivate = async (id, status) => {
    try {
      setConfirmDialog({
        open: true,
        title:
          "Are you sure you want to " +
          (status === "Active" ? "deactivate" : "activate") +
          " this listing?",
        onConfirm: async () => {
          try {
            await apiClient.put(`/admin/listings/${id}`, { status: status });
            await fetchStates(); // Refresh data while staying on the current page
            // Keep current page after refresh
          } catch (error) {
            console.error("Error updating listings status:", error);
          }
        },
      });
    } catch (error) {
      console.error("Error activating listings:", error);
    }
  };

  const handleNameInputChange = (e) => {
    setName(e.target.value);
  };

  const handleCategoryInputChange = (e) => {
    setCategory(e.target.value);
  };

  const handlePropertyTypeInputChange = (e) => {
    setPropertyType(e.target.value);
  };

  const handlePriceInputChange = (e) => {
    setPrice(e.target.value);
  };

  const handleStatusInputChange = (e) => {
    setStatusInput(e.target.value);
  };

  const handleFilterSubmit = () => {
    setNameFilter(name);
    setCategoryFilter(category);
    setPropertyTypeFilter(propertyType);
    setPriceFilter(price);
    setStatusFilter(statusInput);
  };

  const handleClearFilters = () => {
    setNameFilter("");
    setCategoryFilter("");
    setPropertyTypeFilter("");
    setPriceFilter("");
    setStatusFilter("");
    setName("");
    setCategory("");
    setPropertyType("");
    setPrice("");
  };

  // Filter data
  const filteredRows = data.filter((row) => {
    return (
      (nameFilter === "" || row.name.toLowerCase().includes(nameFilter.toLowerCase())) &&
      (categoryFilter === "" ||
        row.category.toLowerCase().includes(categoryFilter.toLowerCase())) &&
      (propertyTypeFilter === "" ||
        row.property_type.toLowerCase().includes(propertyTypeFilter.toLowerCase())) &&
      (priceFilter === "" || row.price.toLowerCase().includes(priceFilter.toLowerCase())) &&
      (statusFilter === "" || row.status.toLowerCase().includes(statusFilter.toLowerCase()))
    );
  });

  const getOtherItemData = (row) => {
    if (!row?.otherItems) return null;
    if (Array.isArray(row.otherItems)) return row.otherItems[0] || null;
    return row.otherItems;
  };

  const getTypeSpecificValue = (row) => {
    const type = (row?.type || row?.property_type || "").toString().toLowerCase();
    const otherItem = getOtherItemData(row);
    const gender = otherItem?.forGender || otherItem?.for_gender || "-";
    const roomType = otherItem?.room_type || otherItem?.roomType || "-";

    if (type === "hostel" || type === "paying_guest" || type === "home_stay") {
      return gender;
    }

    if (type === "flats" || type === "flat" || type === "apartment") {
      return roomType;
    }

    return "-";
  };

  const getStationName = (row) => {
    const stationData = row?.stationItems;
    if (!stationData) return "-";

    if (Array.isArray(stationData)) {
      return stationData[0]?.station_name || stationData[0]?.name || "-";
    }

    return stationData.station_name || stationData.name || "-";
  };

  const getImageList = (row) => {
    const rawImages = row?.images;
    if (!rawImages) return [];

    if (Array.isArray(rawImages)) {
      return rawImages.filter((img) => !!img);
    }

    if (typeof rawImages === "string") {
      return rawImages
        .split(",")
        .map((img) => img.trim())
        .filter((img) => !!img);
    }

    return [];
  };

  const handleOpenImagePreview = (images) => {
    setPreviewImages(images);
    setIsImagePreviewOpen(true);
  };

  const handleCloseImagePreview = () => {
    setIsImagePreviewOpen(false);
    setPreviewImages([]);
    setEnlargedImage("");
  };

  const columns = [
    { Header: "Title", accessor: "name", width: "15%", align: "left" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Property Type", accessor: "property_type", align: "center" },
    { Header: "Type Detail", accessor: "type_detail", align: "center" },
    { Header: "Station Name", accessor: "station_name", align: "center" },
    { Header: "Images", accessor: "images_preview", align: "center" },
    { Header: "Price", accessor: "price", align: "center" },
    { Header: "Added Date", accessor: "added_date", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = filteredRows
    .sort((a, b) => new Date(b.added.at) - new Date(a.added.at))
    .map((data) => ({
      name: <Property name={data.name} email="" />,
      description: <Category title={data.category} description={data.description} />,
      property_type: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {data.property_type}
        </MDTypography>
      ),
      type_detail: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {getTypeSpecificValue(data)}
        </MDTypography>
      ),
      station_name: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {getStationName(data)}
        </MDTypography>
      ),
      images_preview: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <MDBox
            component="button"
            type="button"
            onClick={() => handleOpenImagePreview(getImageList(data))}
            title="View images"
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              bgcolor: "info.main",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              cursor: "pointer",
              p: 0,
            }}
          >
            <VisibilityIcon sx={{ fontSize: "1rem" }} />
          </MDBox>
        </MDBox>
      ),
      price: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {data.price}
        </MDTypography>
      ),
      added_date: new Date(data.added?.at).toLocaleDateString(),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={data.status}
            color={data.status === "Active" || data.status === "active" ? "success" : "warning"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      action: (
        <MDBox display="flex" justifyContent="space-around">
          <IconButton
            onClick={() => handleActivate(data._id, data.status)}
            color={data.status === "Active" || data.status === "active" ? "warning" : "success"}
          >
            <CheckCircleIcon />
          </IconButton>
        </MDBox>
      ),
    }));

  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div style={{ justifyContent: "center" }}>No data found.</div>;

  return (
    <div>
      <MDBox
        display="flex"
        gap="1rem"
        mb="1rem"
        justifyContent="left"
        alignItems="left"
        ml="2%"
        width="90%"
      >
        <MDInput
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={handleNameInputChange}
        />
        <MDInput
          fullWidth
          label="Category"
          variant="outlined"
          value={category}
          onChange={handleCategoryInputChange}
        />
        <MDInput
          fullWidth
          label="Property Type"
          variant="outlined"
          value={propertyType}
          onChange={handlePropertyTypeInputChange}
        />
        <MDInput
          fullWidth
          label="Price"
          variant="outlined"
          value={price}
          onChange={handlePriceInputChange}
        />
        <Select
          fullWidth
          variant="outlined"
          value={statusInput}
          onChange={handleStatusInputChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>Status</em>
          </MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{ color: "#fff" }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClearFilters}
          sx={{ color: "#fff" }}
        >
          Clear
        </Button>
      </MDBox>
      <Divider />
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />
      <Dialog open={isImagePreviewOpen} onClose={handleCloseImagePreview} maxWidth="md" fullWidth>
        <DialogTitle>Listing Images</DialogTitle>
        <DialogContent>
          {previewImages.length === 0 ? (
            <MDTypography variant="caption" color="text">
              No images found.
            </MDTypography>
          ) : (
            <MDBox>
              {previewImages.map((image, index) => (
                <MDBox key={`${image}-${index}`} mb={2}>
                  <MDTypography variant="caption" fontWeight="medium" mb={0.5} display="block">
                    Image {index + 1}
                  </MDTypography>
                  <MDBox
                    component="img"
                    src={image}
                    alt={`Listing image ${index + 1}`}
                    onClick={() => setEnlargedImage(image)}
                    sx={{
                      width: "100%",
                      maxHeight: "50vh",
                      objectFit: "contain",
                      borderRadius: "8px",
                      cursor: "zoom-in",
                    }}
                  />
                </MDBox>
              ))}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseImagePreview}
            variant="contained"
            color="primary"
            sx={{ color: "#fff" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(enlargedImage)}
        onClose={() => setEnlargedImage("")}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>Enlarged Image</DialogTitle>
        <DialogContent>
          <MDBox
            component="img"
            src={enlargedImage}
            alt="Enlarged listing"
            sx={{ width: "100%", maxHeight: "85vh", objectFit: "contain" }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEnlargedImage("")}
            variant="contained"
            color="primary"
            sx={{ color: "#fff" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1300,
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            borderBottom: `1px solid ${darkMode ? "#333" : "#e0e0e0"}`,
          }}
        >
          {confirmDialog.title}
        </DialogTitle>
        <DialogActions
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            padding: "16px 24px",
          }}
        >
          <Button
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
            color="inherit"
            sx={{ color: darkMode ? "#ccc" : "#666" }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (confirmDialog.onConfirm) {
                await confirmDialog.onConfirm();
              }
              setConfirmDialog({ ...confirmDialog, open: false });
            }}
            variant="contained"
            color="primary"
            sx={{ color: "#fff", ml: 1 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
ListingsTableData.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};
export default ListingsTableData;
